module.exports = __webpack_public_path__ + "static/media/hand-bottom.ca986dff.png";